module.exports = __webpack_public_path__ + "static/media/t4.c539b00c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/t4.jpg
// module id = 405
// module chunks = 0